import styled from 'styled-components';
import { LinkWithIconWrapperProps } from '../types/StyledLinkWithIcon.types';

export const LinkWithIconWrapper = styled.div<LinkWithIconWrapperProps>`
  display: flex;
  justify-content: ${({ isMobile }) => (isMobile ? 'center' : 'start')};

  a {
    margin: 12px 8px;

    ${({ isMobile, desktopApperance, mobileAppearance }) =>
      ((!isMobile && desktopApperance === 'secondary') ||
        (isMobile && mobileAppearance === 'secondary')) &&
      '&:hover { color: unset; svg { fill: #fff; stroke: #fff;}}'}

    > div:first-child {
      transform: ${({ isRtl }) => (isRtl ? 'scaleX(-1)' : 'unset')};
    }

    > div:last-child {
      text-decoration: ${({ isMobile, desktopUnderline, mobileUnderline }) =>
        (isMobile && mobileUnderline) || (!isMobile && desktopUnderline)
          ? 'underline'
          : 'none'};

      &:hover {
        text-decoration: ${({ isMobile, mobileUnderline }) =>
          isMobile && mobileUnderline ? 'none' : 'underline'};

        text-underline-offset: ${({
          isMobile,
          desktopUnderline,
          mobileUnderline,
        }) =>
          (isMobile && mobileUnderline) || (!isMobile && desktopUnderline)
            ? '3px'
            : 'unset'};
      }
    }
  }
`;
